import { render, staticRenderFns } from "./PaymentCardBlock.vue?vue&type=template&id=6cde2e85&"
import script from "./PaymentCardBlock.vue?vue&type=script&lang=ts&"
export * from "./PaymentCardBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports